
import { Component, Vue, Provide } from "vue-property-decorator";
import { Toast, PullRefresh, SwipeCell, Dialog } from "vant";
import { getUserInfo, newGetUserInfo } from "@/req/user";
@Component({
  name: "App",
})
export default class extends Vue {
  public isRouterAlive = true;
  @Provide()
  public switchOver = this.reload;
  public reload() {
    this.isRouterAlive = false;
    this.$nextTick(() => {
      this.isRouterAlive = true;
    });
  }
  public created() {
    (window as any).appPage = this; // window变量绑定this
    //   url截取token
    const obj: any = this.$fn.parseQuery(window.location.href);
    // const token = this.$route.query.token;
    // 打印token
    // Dialog.alert({
    //   title: "token",
    //   message: `${obj.token}`,
    //   theme: "round-button",
    // }).then(() => {
    //   // on close
    // });
    // console.log(obj);
    if (obj.version) {
      (window as any).appv = obj.version
          ? obj.version
          : this.$fn.cookies.getVersion();
      this.$fn.cookies.setVersion(obj.version);
    }
    if (obj.token) {
      this.$fn.cookies.setToken(obj.token);
      if (obj.userinfo != 1) this.getInfo(obj.token);
      this.$fn.cookies.setShowNav(1);
    }
    if (obj.userinfo == 1) {
      sessionStorage.setItem("h5jyhInfo", obj.userinfo);
      (window as any).sendEditorInfo();
    }
    if (obj.token) {
      this.getNewInfo();
    }
    if ((window as any).mb) {
      this.$fn.cookies.setIsios((window as any).mb);
    }
  }
  // 截取url
  public parseQuery(url) {
    const o = {};
    const queryString = url.split("?")[1];
    if (queryString) {
      queryString.split("&").forEach((item) => {
        let [key, val] = item.split("=");
        val = val ? decodeURI(val) : true;
        key = key ? decodeURI(key) : true;
        //          转码         无值赋值true
        if (o.hasOwnProperty(key)) {
          //   已有属性转为数组
          o[key] = [].concat(o[key], val);
        } else {
          o[key] = val;
        }
      });
    }
    return o;
  }
  public async getInfo(data) {
    const res = await getUserInfo();
    if (res.code == 200) {
      await this.$store.dispatch("user/authInfo", res.data.userinfo);
    }
  }
  public async getInfos(data) {
    await this.$store.dispatch("user/authInfo", data);
  }
  public async getNewInfo() {
    const res = await newGetUserInfo();
    if (res.code == 200) {
      const idCard = this.$store.state.user.info.idcard
        ? this.$store.state.user.info.idcard
        : "";
      if (!idCard || idCard != res.data.user.id_card) {
        this.$store.state.user.info.idcard = res.data.user.id_card;
      }
    }
  }
}
